import { StyleSheet } from 'react-native';
import App from 'constants/App';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
  },
  headerSmall: {
    flexDirection: 'row',
    padding: 10,
  },
  iconLarge: {
    flex: 0.1,
    alignSelf: 'center',
  },
  iconSmall: {
    flex: 0.5,
    alignSelf: 'center',
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
  },
  textTitleLarge: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  textSmall: {
    flex: 1,
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  wrapper: {
    width: '80%',
    marginHorizontal: 'auto',
  },
  wrapperSmall: {
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  selectLabel: {
    lineHeight: 24,
    fontWeight: '500',
    fontSize: 16,
    marginBottom: 10,
  },
  dateInputContainer: {
    width: '100%',
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  registerOrderButtonContainerLarge: {
    width: '50%',
    marginTop: 25,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  registerOrderButtonContainerSmall: {
    marginVertical: 15,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  orderBtnContainerLarge: {
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
  },
  orderBtnContainerSmall: {
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
  },
  btnTitleOrders: {
    color: '#001C47',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  orderBtnLarge: {
    backgroundColor: '#EEEEEE',
    borderRadius: 10,
    alignSelf: 'center',
    width: '100%',
  },
  orderBtnSmall: {
    backgroundColor: '#EEEEEE',
    borderRadius: 10,
    alignSelf: 'center',
    width: '100%',
  },
  // orders
  topRowForDescriptionOnListOrders: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    width: '80%',
    justifyContent: 'flex-start',
    height: 150,
    paddingVertical: 15,
    borderRadius: 5,
    marginTop: 20,
    zIndex: 0,
  },
  orderItem: {
    flexDirection: 'row',
    justifyContent: 'center',
    flex: 0.5,
  },
  topRowTextForDescription: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    letterSpacing: 0,
    textAlign: 'center',
    color: '#FFFFFF',
  },
  consumptionFooter: {
    alignItems: 'center',
    marginBottom: 15,
  },
  operationsTotal: {
    marginBottom: 5,
  },
  operationsTotalSmall: {
    marginBottom: 5,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  reportDownloadContainer: {
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: 6,
    marginBottom: 50,
  },
  normalText: {
    fontFamily: 'circular-std',
    fontSize: 16,
  },
  paginationContainer: { flexDirection: 'row', alignItems: 'center' },
  paginationButton: {
    padding: 10,
    borderRadius: 5,
    marginLeft: 10,
  },
  datesErrorContainer: {
    flexDirection: 'column',
    alignSelf: 'center',
  },
  textError: {
    color: App.errorColor,
  },
  scrollItemsContainer: {
    flexDirection: 'column',
  },
  scrollItemsContentContainer: {
    width: '80%',
    marginHorizontal: 'auto',
  },
  scrollItemsContentContainerSmall: {
    width: '100%',
    marginHorizontal: 'auto',
  },
  switchesContainer: {
    flex: 1,
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 15,
  },
  switchesContainerSmall: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 75,
    marginRight: 15,
    textAlign: 'left',
  },
  switch: {
    alignSelf: 'center',
    marginTop: 15,
    width: '20%',
  },
  switchTitle: {
    fontSize: 15,
    color: '#001639',
    fontWeight: '400',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
  switchIsCashPaymentContainer: {
    flexDirection: 'column',
    alignSelf: 'center',
    marginLeft: 15,
  },
  switchIsCardPaymentContainer: {
    flexDirection: 'column',
    alignSelf: 'center',
    marginLeft: 15,
  },
  switchIsFiservQrPaymentContainer: {
    flexDirection: 'column',
    alignSelf: 'center',
    marginLeft: 15,
  },
  textInput: {
    fontSize: 14,
    color: '#3f3a40',
    textAlign: 'left',
    borderColor: '#c9c9c9',
    backgroundColor: 'white',
    height: 45,
    width: '100%',
    paddingHorizontal: 16,
    borderWidth: 1,
  },
  containerSummary: {
    flexDirection: 'row', // Dispone las tarjetas en fila
    justifyContent: 'space-between',
    gap: 16, // Espaciado entre las tarjetas
    padding: 16,
    width: '100%',
  },
  card: {
    flex: 1, // Hace que ambas tarjetas ocupen el mismo ancho
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    paddingVertical: 16,
    paddingHorizontal: 20,
    // Sombra sutil para web y móvil
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  label: {
    fontSize: 14,
    color: '#666666',
    marginBottom: 8,
  },
  valueNumber: {
    fontSize: 32,
    fontWeight: '500',
    color: '#1A1A1A',
  },
  valueAmount: {
    fontSize: 32,
    fontWeight: '500',
    color: '#3F51B5', // Color azul similar al de la imagen
  },

});
